import React from "react";

const TickIcon = (props) => {
    return(
        <svg xmlns="http://www.w3.org/2000/svg" width="19.999" height="10.658" viewBox="0 0 19.999 10.658"><path d="M-13370.356 365.556l-4.264-4.265a.983.983 0 0 1 0-1.422.983.983 0 0 1 1.422 0l3.555 3.556 7.916-7.92a.983.983 0 0 1 1.422 0 .983.983 0 0 1 0 1.422l-8.629 8.629a.784.784 0 0 1-.709.3.923.923 0 0 1-.713-.3zm-5.076 0l-4.264-4.265a.982.982 0 0 1 0-1.422.983.983 0 0 1 1.422 0l4.264 4.265a.981.981 0 0 1 0 1.422.784.784 0 0 1-.709.3.922.922 0 0 1-.714-.3zm5.38-5.281a.979.979 0 0 1 0-1.418l3.249-3.351a.983.983 0 0 1 1.422 0 .983.983 0 0 1 0 1.422l-3.249 3.348a.913.913 0 0 1-.709.307.927.927 0 0 1-.714-.308z" transform="translate(13380.001 -355.201)" fill={props.fill} /></svg>
    )
}

export default TickIcon;
